import React, { useEffect } from 'react'
import { useSnackbar } from 'notistack'
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography
} from '@mui/material'
import { FormProvider, useForm } from 'react-hook-form'
import { useNavigate, useParams } from 'react-router-dom'
import SubmitButton from './commonUIComponents/SubmitButton'
import updateEmailAddressService from '../services/updateEmailAddressService'

const UpdateEmailAddressPage = () => {
  const { uuid } = useParams()
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const methods = useForm({ mode: 'onChange' })
  const { handleSubmit, formState: { errors } } = methods

  useEffect(() => {
    updateEmailAddressService.validateUpdateEmailAddressToken(uuid)
      .then(res => console.log('Checking token ...'))
      .catch(err => {
        enqueueSnackbar(err.response?.data?.message, { variant: 'warning' })
        navigate('/login')
      })
  }, [])

  const submitHandler = values => {
    return updateEmailAddressService.updateEmailAddress(uuid)
      .then(res => {
        enqueueSnackbar('Successfully updated the email address !', { variant: 'success' })
        navigate('/login')
      })
      .catch(err => {
        enqueueSnackbar(err.response?.data?.message, { variant: 'warning' })
        navigate('/login')
      })
  }

  return (
    <>
      <Box>
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(submitHandler)}>
            <Grid container spacing={2}>
              <Grid item xs={4} />
              <Grid item xs={4}>
                <Card variant="outlined">
                  <CardContent>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography variant="h5" component="div">
                          Update Email Address
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body2">
                          Are you sure you want to update your account email address?
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <SubmitButton buttonLabel="Yes" loadingLabel="Updating ..." />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={4} />
            </Grid>
          </form>
        </FormProvider>
      </Box>
    </>
  )
}

export default UpdateEmailAddressPage
